import { useMemo } from 'react';
import { useLayout } from '../layouts/layout-context';
import { useTables } from '../tables-context';
import { getFeaturesMaxRows } from '../utils/get-features-max-rows';
import { Column } from './column';

export const useRenderColumns = () => {
  const { activeTable, elements } = useTables();
  const { layout, rowIndexes, rowsCount } = useLayout();

  const maxFeaturesRows = getFeaturesMaxRows({
    elements,
    rowIndexes,
    rowsCount
  });

  const hasHead = layout === 'comparisonTable';
  const isComparisonTableMobile = layout === 'comparisonTableMobile';

  const { columns = [] } = activeTable ?? {};
  const derivedColumns = useMemo(() => {
    if (isComparisonTableMobile) {
      const [{ features: headFeatures }, ...columnsWithoutHead] = columns;

      const maxFeaturesRowsArray = Array.from({ length: maxFeaturesRows });

      return columnsWithoutHead.map(({ features, ...rest }, columnIndex) => {
        const featuresWithHeadFeatures = maxFeaturesRowsArray.map(
          (_, index) => {
            const defaultFeature = {
              id: `feature-${columnIndex}-${index}`,
              text: '',
              hint: '',
              icon: null
            };

            const roundedIndex = Math.floor(index / 2);
            const rowType = index % 2;
            const rowMap = [headFeatures[roundedIndex], features[roundedIndex]];

            return rowMap[rowType] ?? defaultFeature;
          }
        );

        return {
          ...rest,
          features: featuresWithHeadFeatures
        };
      });
    }

    return columns;
  }, [columns, isComparisonTableMobile, maxFeaturesRows]);

  return derivedColumns.map((column, columnIndex) => (
    <Column
      key={column.id}
      columnIndex={columnIndex}
      isHeadColumn={hasHead && !columnIndex}
      {...column}
    />
  ));
};
